import { parse } from 'tldts'

/**
 * Whether a domain a customer typed is a subdomain (rezerwacje.gabinet.pl) or a main domain (gabinet.pl), read from the
 * public suffix list, so endings of any length (.online, .clinic) and second-level ones (.com.pl, .info.pl) count right.
 * "www." in front still means the main domain: the dialog asks for www as a separate record.
 */
export function isSubdomain (input: string | null | undefined): boolean {
  if (!input) {
    return false
  }
  const { subdomain } = parse(input.trim(), { allowPrivateDomains: false })
  return !!subdomain && subdomain !== 'www'
}
